<template>
    <div class="container">
        <div v-html="data[0].question.text"></div>
        <div class="continue-button-overlay">
            <span @click.prevent="$emit('next')" class="continue-button">Verder ></span>
        </div>
    </div>
</template>

<script>

    export default {
        'props': {
            data: {}
        }
    }
</script>
